module.exports = __webpack_public_path__ + "dac2fca7ba8512baa24172f1171c961f.woff2";


//////////////////
// WEBPACK FOOTER
// ./application/font/SourceSansPro-Italic.woff2
// module id = 354
// module chunks = 0